import { Link } from "react-router"
import { ArrowLeft } from "lucide-react"
import { useTranslation } from "react-i18next"
import RentForm from "./sections/rent/RentForm"
import { useGetProject } from "../hooks/useGetProject"
import { Loading } from "./Loading"
import NotFound from "./NotFound"
import { LanguageSwitch } from "../components/LanguageSwitch"

function Rent() {
  const { project, isLoading } = useGetProject()
  const { t } = useTranslation('common')

  if (isLoading) return <Loading />

  if (!project) return <NotFound />

  const logoUrl = project.logoImageFiles?.[0]?.s3Url

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="sticky top-0 z-10 border-b border-gray-200/80 bg-white/95 backdrop-blur-sm">
        <div className="mx-auto flex h-14 max-w-2xl items-center gap-3 px-4 sm:px-6">
          <Link
            to="/"
            aria-label={t('backToHome')}
            className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-900"
          >
            <ArrowLeft className="h-5 w-5" aria-hidden />
          </Link>
          <div className="flex min-w-0 flex-1 items-center gap-2.5">
            {logoUrl ? (
              <img src={logoUrl} alt="" className="h-8 w-8 shrink-0 object-contain" />
            ) : null}
            <span className="truncate text-base font-semibold text-gray-900">{project.name}</span>
          </div>
          <LanguageSwitch variant="dark" />
        </div>
      </header>

      <main className="mx-auto w-full max-w-2xl px-4 py-5 sm:px-6 sm:py-6">
        <RentForm />
      </main>
    </div>
  )
}

export default Rent
